import React from "react";
import ProductCard from "../components/ProductCard";
import { Product } from "../interfaces/home_entity";
import "./DiscountedProducts.css";

interface DiscountedProductsProps {
  products: Product[];
}

const DiscountedProducts: React.FC<DiscountedProductsProps> = ({ products }) => (
  <div className="left-section">
    <h3>🔥 Discounted Products</h3>
    <div className="product-grid small-grid">
      {products
        .filter(p => p.discountedPrice != null && p.discountedPrice > 0)
        .slice(0, 4)
        .map((product) => {

          const discountPercent = product.discountedPrice ?? 0;

          return (
            <div key={product.id} className="discount-wrapper">
              <span className="discount-badge">{discountPercent}% OFF</span>
              <ProductCard product={product} />
            </div>
          );
        })}
    </div>
  </div>
);

export default DiscountedProducts;